import * as React from 'react';

// Utils
import { isNilOrEmpty, isNil } from '@src/shared/src/util/general';
import { getUserFullname } from '@src/shared/src/util/users';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
// Constants
// Actions
import { selectors } from '@src/shared/src';
// Models
import { PassengerModel } from '@src/shared/src/models';
// Interfaces
import { IRootState } from '@src/store';
// Components
import { SidebarRoute } from '@toolkit/ui';
import { AccountCirlceIcon } from '@toolkit/ui/icons';
// Styles

type Props = {
  onOpenTravelPolicies: (passenger: PassengerModel) => void;
};

const SideBarPassengersInfo: React.FC<Props> = ({ onOpenTravelPolicies }) => {
  const { t } = useTranslation();
  const passengers = useSelector((state: IRootState) =>
    selectors.search.searchPassengers(state.search),
  );

  const renderTravelPoliciesAction = (passenger: PassengerModel) => {
    if (passenger.isFirst && passenger.hasTravelPolicies) {
      return (
        <button
          type="button"
          className="sidebar-route-action"
          data-rh={t('SideBarPassengersInfo.travelPolicies.tooltip')}
          data-rh-at="top"
          onClick={() => onOpenTravelPolicies(passenger)}>
          <i className="material-symbols">verified_user</i>
        </button>
      );
    }

    return null;
  };

  const filteredPassengers = passengers.map((passenger: PassengerModel, index: number) => {
    if (!isNil(passenger)) {
      return (
        <SidebarRoute
          key={`passenger-${index}`}
          iconLeft={<AccountCirlceIcon />}
          iconRight={renderTravelPoliciesAction(passenger)}>
          {getUserFullname(passenger)}
          &nbsp;
          {!isNilOrEmpty(passenger.membershipCards) && `(${passenger.membershipCards.join(' | ')})`}
        </SidebarRoute>
      );
    }
    return null;
  });

  return (
    <div className="sidebar-route-section">
      <div className="sidebar-title">{t('tripBookedInfo.label.passengers')}</div>
      {filteredPassengers}
    </div>
  );
};

export default SideBarPassengersInfo;
